import { Navbar, Stack, Group, Flex, Space, Container } from "@mantine/core";
import { useMediaQuery } from '@mantine/hooks';
import {
  ChartLine,
  ListDetails,
  Award,
  Road,
  Activity,
  ShieldCheck,
  ArrowLeft,
} from "tabler-icons-react";
import { useLocation } from "react-router-dom";
import NCENavbarLink from "../NCENavbarLink/NCENavbarLink";
import CoBrandFintechlab from "../../../images/CoBrand-Fintech-lab.jpg";

import './NCENavbar.css' // Import the CSS file

export default function NCENavbar() {
  const inactiveColour = "#C3C3C3";
  const activeColour = "#314DA3";
  const isMobile = useMediaQuery('(max-width: 1090px)');

  const location = useLocation();

  const path = location.pathname;

  // Hide the navbar entirely on auth-related routes so the
  // login / register / password-reset pages render cleanly.
  const AUTH_ROUTES = ["/login", "/register", "/forgot-password"];
  if (AUTH_ROUTES.includes(path) || path.startsWith("/reset-password")) {
    return null;
  }

  console.log(path);

  // Inside the admin panel, swap the regular trading links for the admin
  // section's own navigation (Waves / Admin access / Back to app). Same
  // navbar chrome — logo, white background, NCENavbarLink styling — just a
  // different set of destinations, so there's only ever one navbar on screen
  // instead of this one plus AdminShell's own sidebar.
  const isAdminRoute = path.startsWith("/admin");

  const adminLinks = (
    <>
      <NCENavbarLink
        title={"Waves"}
        icon={
          <Activity color={path.startsWith("/admin/waves") || path === "/admin" ? activeColour : inactiveColour} />
        }
        color={path.startsWith("/admin/waves") || path === "/admin" ? activeColour : inactiveColour}
        active={path.startsWith("/admin/waves") || path === "/admin"}
        url="/admin/waves"
      />
      <NCENavbarLink
        title={"Admin Access"}
        icon={
          <ShieldCheck color={path === "/admin/access" ? activeColour : inactiveColour} />
        }
        color={path === "/admin/access" ? activeColour : inactiveColour}
        active={path === "/admin/access"}
        url="/admin/access"
      />
      <NCENavbarLink
        title={"Back to App"}
        icon={<ArrowLeft color={inactiveColour} />}
        color={inactiveColour}
        active={false}
        url="/"
      />
    </>
  );

  const renderDesktopView = (
    <Navbar
      width={{ base: 220 }} 
      height={"full"}
      p="xs"
      sx={{backgroundColor:"white"}}
      >
      <Stack spacing={4}>
        <Space h="md" />
        <Flex
          gap="md"
          justify="center"
          align="flex-start"
          direction="row"
          wrap="wrap"
        >
          <img
            src={CoBrandFintechlab}
            alt="NUS CoBrand FinTech Lab Logo"
            className="navbar__logo"
          />
        </Flex>
        <Space h="xl" />
        {isAdminRoute ? adminLinks : <>
        <NCENavbarLink
          title={"Journey"}
          icon={
            <Road color={path === "/journney" ? activeColour : inactiveColour} />
          }
          color={path === "/journey" ? activeColour : inactiveColour}
          active={path === "/journey"}
          url="/journey"
        />
        <NCENavbarLink
          title={"Trades"}
          icon={
            <ChartLine color={path === "/trade" || path === "/trade/btcusd" || path === "/trade/ethusd" || path === "/trade/xrpusd"? activeColour : inactiveColour} />
          }
          color={path === "/trade" || path === "/trade/btcusd" || path === "/trade/ethusd" || path === "/trade/xrpusd"? activeColour : inactiveColour}
          active={path === "/trade"|| path === "/trade/btcusd" || path === "/trade/ethusd"|| path === "/trade/xrpusd"}
          url="/trade"
        />
        <NCENavbarLink
          title={"Your Assets"}
          icon={
            <ListDetails
              color={path === "/assets" ? activeColour : inactiveColour}
            />
          }
          color={path === "/assets" ? activeColour : inactiveColour}
          active={path === "/assets"}
          url="/assets"
        />
        <NCENavbarLink
          title={"Contest"}
          icon={
            <Award
              color={path.startsWith("/contest/") || path === "/contest" ? activeColour : inactiveColour}
            />
          }
          color={path.startsWith("/contest/") || path === "/contest" ? activeColour : inactiveColour}
          active={path.startsWith("/contest/") || path === "/contest" }
          url="/contest"
        />
        {/* <NCENavbarLink
          title={"Learn"}
          icon={
            <News color={path === "/blog" ? activeColour : inactiveColour} />
          }
          color={path === "/blog" ? activeColour : inactiveColour}
          active={path === "/blog"}
          url="/blog"
        /> */}
        {/* <NCENavbarLink
          title={"Crypto Stats"}
          icon={
            <Aperture color={path === "/viz" ? activeColour : inactiveColour} />
          }
          color={path === "/viz" ? activeColour : inactiveColour}
          active={path === "/viz"}
          url="/viz"
        /> */}
        </>}
      </Stack>
    </Navbar>
  )

  const renderMobileView = (
  <Container
    width={{ base: '100%' }} 
    height={"auto"}
    p="xs"
    wrap="wrap"
    sx={{ position:"fixed", bottom: 0, left: 0, right: 0, zIndex: 100, overflow: "hidden", backgroundColor:"white" }}
    >
    <Group spacing={4} grow>
      {/* <Space h="md" />
      <Flex
        mih={50}
        gap="md"
        justify="center"
        align="flex-start"
        direction="row"
        wrap="wrap"
      >
      </Flex>
      <Space h="xl" /> */}
      {isAdminRoute ? adminLinks : <>
      <NCENavbarLink
        title={"Journey"}
        icon={
          <Road color={path === "/journey" ? activeColour : inactiveColour} />
        }
        color={path === "/journey" ? activeColour : inactiveColour}
        active={path === "/journey"}
        url="/journey"
      />
      <NCENavbarLink
        title={"Trades"}
        icon={
          <ChartLine color={path === "/trade" || path === "/trade/btcusd" || path === "/trade/ethusd" || path === "/trade/xrpusd" ? activeColour : inactiveColour} />
        }
        color={path === "/trade" || path === "/trade/btcusd" || path === "/trade/ethusd"|| path === "/trade/xrpusd" ? activeColour : inactiveColour}
        active={path === "/trade"|| path === "/trade/btcusd" || path === "/trade/ethusd"|| path === "/trade/xrpusd"}
        url="/trade"
      />
      <NCENavbarLink
        title={"Assets"}
        icon={
          <ListDetails
            color={path === "/assets" ? activeColour : inactiveColour}
          />
        }
        color={path === "/assets" ? activeColour : inactiveColour}
        active={path === "/assets"}
        url="/assets"
      />
      <NCENavbarLink
        title={"Contest"}
        icon={
          <Award
            color={path.startsWith("/contest/") || path === "/contest" ? activeColour : inactiveColour}
          />
        }
        color={path.startsWith("/contest/") || path === "/contest" ? activeColour : inactiveColour}
        active={path.startsWith("/contest/") || path === "/contest" }
        url="/contest"
      />
      {/* <NCENavbarLink
        title={"Learn"}
        icon={
          <News color={path === "/blog" ? activeColour : inactiveColour} />
        }
        color={path === "/blog" ? activeColour : inactiveColour}
        active={path === "/blog"}
        url="/blog"
      /> */}
      {/* <NCENavbarLink
        title={"Stat"}
        icon={
          <Aperture color={path === "/viz" ? activeColour : inactiveColour} />
        }
        color={path === "/viz" ? activeColour : inactiveColour}
        active={path === "/viz"}
        url="/viz"
      /> */}
      </>}
    </Group>
  </Container>
  );

  return isMobile ? renderMobileView : renderDesktopView;
}
